<!--begin::Main-->
<ngx-spinner class="custom-spinner"
bdColor="rgba(255,255,255,1)"
  size="medium"
  color="#fff"
  type="ball-atom"
  [fullScreen]="true"
>
<span class="loader">
  <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
</span>
</ngx-spinner>
<div class="app-main flex-column flex-row-fluid" id="kt_app_main">
  <!--begin::Content wrapper-->
  <div class="d-flex flex-column flex-column-fluid">
    <!--begin::Toolbar-->
    <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
      <!--begin::Toolbar container-->
      <div
        id="kt_app_toolbar_container"
        class="app-container container-fluid d-flex flex-stack"
      >
        <!--begin::Page title-->
        <div
          class="page-title d-flex flex-column justify-content-center flex-wrap me-3"
        >
          <!--begin::Title-->
          <div class="d-flex align-items-center">
            <h1 class="page-heading">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="41"
                viewBox="0 0 40 41"
                fill="none"
              >
                <g filter="url(#filter0_d_859_3648)">
                  <path
                    d="M23.1797 21.7462H21.8122V21.8495C21.8122 22.5376 21.2652 23.0882 20.5815 23.0882H19.4191C18.7353 23.0882 18.1883 22.5376 18.1883 21.8495V21.7462H16.8208C16.5473 21.7462 16.2396 21.6774 16.0003 21.5054L14.9404 20.8172V24.6021C14.9404 24.9118 15.2139 25.1871 15.5216 25.1871H24.4789C24.7866 25.1871 25.0601 24.9118 25.0601 24.6021V20.8172L24.0003 21.5054C23.7609 21.643 23.4874 21.7462 23.1797 21.7462Z"
                    fill="#265D91"
                  />
                  <path
                    d="M25.1618 17.1699H22.29V15.6559C22.29 15.3118 22.0165 15.071 21.7088 15.071H18.29C17.9482 15.071 17.7088 15.3463 17.7088 15.6559V17.1699H14.8371C14.5294 17.1699 14.2559 17.4452 14.2559 17.7549V18.9592C14.2559 19.1656 14.3584 19.3377 14.5294 19.4409L16.5123 20.714C16.6148 20.7828 16.7174 20.8172 16.82 20.8172H18.1875V20.7484C18.1875 20.0602 18.7345 19.5097 19.4183 19.5097H20.5806C21.2644 19.5097 21.8114 20.0602 21.8114 20.7484V20.8172H23.1789C23.2815 20.8172 23.3841 20.7828 23.4866 20.714L25.4695 19.4409C25.6405 19.3377 25.743 19.1656 25.743 18.9592V17.7549C25.743 17.4108 25.5037 17.1699 25.1618 17.1699ZM21.1277 17.1699H18.9054V16.2753H21.1277V17.1699Z"
                    fill="#265D91"
                  />
                  <path
                    d="M20.5814 22.1592C20.7523 22.1592 20.8549 22.0215 20.8549 21.8839V20.714C20.8549 20.5419 20.7182 20.4387 20.5814 20.4387H19.419C19.2481 20.4387 19.1455 20.5764 19.1455 20.714V21.8495C19.1455 22.0215 19.2823 22.1247 19.419 22.1247H20.5814V22.1592Z"
                    fill="#265D91"
                  />
                  <path
                    d="M24.342 29.5914C23.0429 30.2108 21.5728 30.5893 20.0002 30.5893C18.4275 30.5893 16.9916 30.2452 15.6925 29.5914V30.6237C15.6925 31.0366 15.5557 31.4495 15.3506 31.7592C16.7865 32.3785 18.3933 32.6882 20.0343 32.6882C21.6754 32.6882 23.2822 32.3441 24.7181 31.7592C24.513 31.4495 24.3762 31.0366 24.3762 30.6237V29.5914H24.342Z"
                    fill="#265D91"
                  />
                  <path
                    d="M26.4277 12.5936C27.932 13.8667 29.0944 15.5527 29.6414 17.4796C30.0517 17.342 30.5303 17.2731 30.9747 17.2731C31.2482 17.2731 31.5218 17.3075 31.7953 17.342C31.0431 14.3484 29.1628 11.7678 26.667 10.1161C26.667 10.1506 26.667 10.185 26.667 10.2194V11.6301C26.667 11.9742 26.5987 12.3183 26.4277 12.5936Z"
                    fill="#265D91"
                  />
                  <path
                    d="M10.3248 17.4796C10.9059 15.5527 12.0342 13.8667 13.5384 12.5936C13.4017 12.3183 13.2991 11.9742 13.2991 11.6301V10.2194C13.2991 10.185 13.2991 10.1506 13.2991 10.1161C10.8034 11.7678 8.92304 14.3484 8.13672 17.342C8.41022 17.3075 8.68373 17.2731 8.95723 17.2731C9.47005 17.2731 9.9145 17.342 10.3248 17.4796Z"
                    fill="#265D91"
                  />
                  <path
                    d="M19.9998 6.05591C21.6613 6.05591 23.0083 4.70025 23.0083 3.02796C23.0083 1.35566 21.6613 0 19.9998 0C18.3382 0 16.9912 1.35566 16.9912 3.02796C16.9912 4.70025 18.3382 6.05591 19.9998 6.05591Z"
                    fill="#265D91"
                  />
                  <path
                    d="M15.3155 11.9397H24.6488C24.8198 11.9397 24.9565 11.8021 24.9565 11.6301V10.2193C24.9565 8.70534 23.9651 7.39781 22.6318 6.9505C21.8796 7.46663 20.9565 7.77631 19.9651 7.77631C18.9736 7.77631 18.0506 7.46663 17.2984 6.9505C15.9309 7.43222 14.9736 8.70534 14.9736 10.2193V11.6301C15.0078 11.8021 15.1446 11.9397 15.3155 11.9397Z"
                    fill="#265D91"
                  />
                  <path
                    d="M11.6581 25.9097C10.906 26.4258 9.9829 26.7699 8.99145 26.7699C8 26.7699 7.07692 26.4602 6.2906 25.9097C4.95726 26.3914 4 27.6989 4 29.2129V30.6236C4 30.7957 4.13675 30.9333 4.30769 30.9333H13.641C13.812 30.9333 13.9487 30.7957 13.9487 30.6236V29.2129C13.9829 27.6645 13.0256 26.3914 11.6581 25.9097Z"
                    fill="#265D91"
                  />
                  <path
                    d="M8.99195 25.0494C10.6535 25.0494 12.0005 23.6938 12.0005 22.0215C12.0005 20.3492 10.6535 18.9935 8.99195 18.9935C7.33037 18.9935 5.9834 20.3492 5.9834 22.0215C5.9834 23.6938 7.33037 25.0494 8.99195 25.0494Z"
                    fill="#265D91"
                  />
                  <path
                    d="M33.6747 25.9097C32.9226 26.4602 31.9995 26.7699 31.008 26.7699C30.0166 26.7699 29.0935 26.4602 28.3414 25.9097C27.008 26.3914 26.0508 27.6989 26.0508 29.2129V30.6236C26.0508 30.7957 26.1875 30.9333 26.3585 30.9333H35.6918C35.8627 30.9333 35.9995 30.7957 35.9995 30.6236V29.2129C35.9995 27.6645 35.0422 26.3914 33.6747 25.9097Z"
                    fill="#265D91"
                  />
                  <path
                    d="M31.0085 25.0494C32.6701 25.0494 34.0171 23.6938 34.0171 22.0215C34.0171 20.3492 32.6701 18.9935 31.0085 18.9935C29.347 18.9935 28 20.3492 28 22.0215C28 23.6938 29.347 25.0494 31.0085 25.0494Z"
                    fill="#265D91"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_d_859_3648"
                    x="0"
                    y="0"
                    width="39.999"
                    height="40.6882"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_859_3648"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_859_3648"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
              Salariés
            </h1>
            <div class="dropdown">
              <button
                class="btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                type="button"
                id="dropdownMenuButton"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="42"
                  height="42"
                  viewBox="0 0 42 42"
                  fill="none"
                >
                  <g filter="url(#filter0_d_859_3822)">
                    <circle cx="20" cy="18" r="13" fill="white" />
                  </g>
                  <path
                    d="M19.667 13V23"
                    stroke="#265D91"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                  <path
                    d="M15 18.3333H25"
                    stroke="#265D91"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                  <defs>
                    <filter
                      id="filter0_d_859_3822"
                      x="0"
                      y="0"
                      width="42"
                      height="42"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dx="1" dy="3" />
                      <feGaussianBlur stdDeviation="4" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_859_3822"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_859_3822"
                        result="shape"
                      />
                    </filter>
                  </defs>
                </svg>
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <a
                  class="dropdown-item cursor-pointer"
                  (click)="openModaladd(add_employee)"
                  >Ajout unitaire
                </a>
                <a class="dropdown-item cursor-pointer" (click)="downloadCsv()"
                  >Télécharger un modèle d'ajout en masse</a
                >
                <a
                  class="dropdown-item cursor-pointer"
                  (click)="openModalBulk(add_masse)"
                  >Ajout en masse
                </a>
              </div>
            </div>
            <!--begin::Menu-->
          </div>
          <!--end::Title-->
          <!--begin::Breadcrumb-->
          <ul
            class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1"
          >
            <!--begin::Item-->
            <li class="breadcrumb-item text-muted">
              <a routerLink="/accueil" class="text-muted">Accueil</a>
            </li>
            <!--end::Item-->
            <!--begin::Item-->
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <!--end::Item-->
            <!--begin::Item-->
            <li class="breadcrumb-item text-muted">Nos salariés</li>
            <!--end::Item-->
          </ul>
          <!--end::Breadcrumb-->
        </div>
        <!--end::Page title-->
        <!--begin::Actions-->

        <!--end::Actions-->
      </div>
      <!--end::Toolbar container-->
    </div>
    <!--end::Toolbar-->
    <div id="kt_app_content" class="app-content flex-column-fluid mb-15">
      <!--begin::Content container-->
      <div id="kt_app_content_container" class="app-container container-fluid">
        <!--begin::Card-->
        <div class="card">
          <!--begin::Card header-->
          <div class="card-body" [formGroup]="searchForm">
            <div class="title mb-10">
              <h4>Recherche</h4>
            </div>
            <div class="row mb-5">
              <div class="col-lg-6">
                <div class="input-group search-libre">
                  <span class="input-group-text">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                        fill="#7E7C7C"
                      />
                    </svg>
                  </span>

                  <input
                    type="text"
                    data-kt-customer-table-filter="search"
                    class="form-control ps-5"
                    placeholder="Rechercher"
                    formControlName="search" (keyup.enter)="searchSalarie()"
                  />
                  <div class="tooltip-container tooltip-info">
                    <div class="tooltip-trigger">
                      <i
                        class="fa-solid fa-circle-info"
                        style="font-size: 20px"
                      ></i>
                    </div>
                    <div class="tooltip-content">
                      <div class="content">
                        <h4>Opérateur AND :</h4>
                        <p>
                          Utilisez l'opérateur AND pour spécifier que les
                          résultats doivent inclure plusieurs termes.
                        </p>
                        <p>
                          Exemple : software AND engineer renverra des profils
                          qui mentionnent à la fois "software" et "engineer".
                        </p>
                        <h4>Opérateur OR :</h4>
                        <p>
                          Utilisez l'opérateur OR pour spécifier que les
                          résultats peuvent inclure l'un des termes.
                        </p>
                        <p>
                          Exemple : sales OR marketing renverra des profils qui
                          mentionnent soit "sales" soit "marketing".
                        </p>
                        <h4>Opérateur NOT :</h4>
                        <p>
                          Utilisez l'opérateur NOT pour exclure des termes
                          spécifiques des résultats.
                        </p>
                        <p>
                          Exemple : developer NOT manager renverra des profils
                          qui mentionnent "developer" mais pas "manager".
                        </p>
                        <h4>Guillemets pour une expression exacte :</h4>
                        <p>
                          Utilisez des guillemets pour rechercher une expression
                          exacte.
                        </p>
                        <p>
                          Exemple : "product manager" renverra des profils qui
                          mentionnent exactement "product manager".
                        </p>
                        <h4>Parenthèses pour grouper des opérations :</h4>
                        <p>
                          Utilisez des parenthèses pour définir l'ordre
                          d'évaluation des opérations.
                        </p>
                        <p>
                          Exemple : (sales OR marketing) AND manager renverra
                          des profils qui mentionnent "sales" ou "marketing" et
                          "manager".
                        </p>
                        <h4>Recherche standard :</h4>
                        <p>
                          Si aucun opérateur n'est spécifié dans la recherche,
                          le texte sera interprété comme s'il était entre
                          guillemets.
                        </p>
                        <p>
                          Exemple : La recherche product manager sera traitée
                          comme "product manager", suivant la règle 4.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tools">
              <div class="row mb-3">
                <div class="col-lg-3">
                  <input
                    type="text"
                    name="first_name"
                    formControlName="name"
                    id="Nom"
                    class="form-control form-control-solid mb-3"
                    placeholder="Nom et prénom"
                  />
                </div>
                <div class="col-lg-3">
                  <input
                    type="text"
                    name="first_name"
                    formControlName="poste"
                    id="Nom"
                    class="form-control form-control-solid mb-3"
                    placeholder="Poste"
                  />
                </div>
                <div class="col-lg-3 mb-3">
                  <ng-select
                    [items]="listprojet"
                    class="form-select"
                    bindLabel="name"
                    [notFoundText]="'Aucun élément trouvé'"
                    [multiple]="true"
                    formControlName="project_id"
                    bindValue="id"
                    [placeholder]="'Projet'"
                    autoComplete
                  >
                  </ng-select>
                </div>
                <div class="col-lg-3 mb-3">
                  <ng-select
                    [items]="skillsList"
                    class="form-select"
                    bindLabel="name_FR"
                    formControlName="skillsOr"
                    bindValue="name_FR"
                    [multiple]="true"
                    [placeholder]="'Compétence (ou)'"
                    [notFoundText]="'Aucun élément trouvé'"
                    autoComplete
                  >
                  </ng-select>
                </div>
              </div>
              <div class="row mb-3" *ngIf="!isCollapsed">
                <div class="col-lg-3 mb-3">
                  <ng-select
                    [items]="skillsList"
                    class="form-select"
                    bindLabel="name_FR"
                    formControlName="skillsAnd"
                    bindValue="name_FR"
                    [multiple]="true"
                    [placeholder]="' compétence (et)'"
                    [notFoundText]="'Aucun élément trouvé'"
                    autoComplete
                  >
                  </ng-select>
                </div>
                <div class="col-lg-3">
                  <input
                    type="number"
                    name="exper"
                    id="experience_min"
                    formControlName="min_experience_years"
                    oninput="validity.valid||(value='0');"
                    min="0"
                    class="form-control form-control-solid mb-3"
                    placeholder=" Expérience min "
                  />
                </div>
                <div class="col-lg-3">
                  <input
                    type="number"
                    min="0"
                    name="exper"
                    id="experience_max"
                    formControlName="max_experience_years"
                    oninput="validity.valid||(value='0');"
                    min="0"
                    class="form-control form-control-solid mb-3"
                    placeholder=" Expérience max"
                  />
                </div>
                <div class="col-lg-3 mb-3">
                  <div class="combined-input">
                    <input
                      type="number"
                      name="number1"
                      min="0"
                      (keypress)="keyPress($event)"
                      formControlName="salary"
                      class="nb1"
                      placeholder="Salaire"
                      id="Salaire"
                      min="0"
                      oninput="validity.valid||(value='0');"
                    />
                    <div class="euro">
                      <svg
                        width="11"
                        height="11"
                        viewBox="0 0 11 11"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                          fill="#4B4B4B"
                        />
                      </svg>
                    </div>
                    <input
                      type="number"
                      formControlName="salary_range"
                      name="number2"
                      (input)="onSalaryRangeInput($event)"
                      class="nb2"
                      value="1"
                      id="marge_tjm"
                      min="0"
                      oninput="validity.valid||(value='0');"
                    />
                    <div class="icon">
                      <svg
                        width="20"
                        height="15"
                        viewBox="0 0 19 11"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.37 10L1.352 5.548V10H0.0780001V0.242H1.352V4.764L5.384 0.242H6.994L2.57 5.128L7.036 10H5.37Z"
                          fill="#4B4B4B"
                        />
                        <path
                          d="M13.889 8.739C14.435 8.739 14.9117 8.62633 15.319 8.401C15.735 8.167 16.06 7.82467 16.294 7.374H18.075C17.737 8.24067 17.1953 8.908 16.45 9.376C15.7047 9.844 14.851 10.078 13.889 10.078C12.875 10.078 11.9737 9.805 11.185 9.259C10.3963 8.70433 9.846 7.96767 9.534 7.049H8.338V6.035H9.3C9.28267 5.79233 9.274 5.60167 9.274 5.463C9.274 5.32433 9.28267 5.13367 9.3 4.891H8.338V3.877H9.534C9.846 2.95833 10.3963 2.226 11.185 1.68C11.9737 1.12533 12.875 0.847999 13.889 0.847999C14.8423 0.847999 15.6917 1.08633 16.437 1.563C17.191 2.031 17.737 2.69833 18.075 3.565H16.294C16.06 3.11433 15.735 2.77633 15.319 2.551C14.9117 2.317 14.435 2.2 13.889 2.2C13.2563 2.2 12.6973 2.34733 12.212 2.642C11.7353 2.93667 11.3713 3.34833 11.12 3.877H13.889V4.891H10.834C10.808 5.073 10.795 5.26367 10.795 5.463C10.795 5.66233 10.808 5.853 10.834 6.035H13.889V7.049H11.12C11.3713 7.58633 11.7353 8.00233 12.212 8.297C12.6973 8.59167 13.2563 8.739 13.889 8.739Z"
                          fill="#4B4B4B"
                        />
                      </svg>
                    </div>
                    <div class="plusetmois">
                      <i class="fa-solid fa-plus-minus"></i>
                    </div>
                  </div>
                </div>

                <div class="col-lg-3"></div>
                <div class="col-lg-3"></div>
              </div>
              <div class="row mb-3 mb-0-sm">
                <div class="col-lg-3 mb-3"></div>
                <div class="col-lg-3 mb-3"></div>
                <div class="col-lg-3 mb-3"></div>
                <div class="col-lg-3 mb-3 mt-2 seemore">
                  <a
                    [ngClass]="{
                      'show-more-button': !isCollapsed,
                      'emphasized-button': isCollapsed
                    }"
                    (click)="toggleCollapsible()"
                    class="show-more-button"
                  >
                    {{
                      isCollapsed
                        ? "Voir plus de critères de recherche"
                        : "Voir moins"
                    }}
                  </a>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-3"></div>
                <div class="col-lg-3"></div>
                <div class="col-lg-3"></div>
                <div class="col-lg-3 rechercher">
                  <div class="mb-3 search-btn d-flex justify-content-end">
                    <div class="align-items-center">
                      <button
                        type="submit"
                        class="me-5"
                        (click)="searchSalarie()"
                      >
                        <svg
                          width="15"
                          height="15"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                            fill="white"
                          />
                        </svg>
                        Rechercher
                      </button>
                    </div>
                    <div class="resett-btn">
                      <div
                        class="reset-icon cursor-pointer"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Réinitialiser"
                      >
                        <a>
                          <img
                            src="/assets/media/icons/reset.png"
                            alt=""
                            width="30px"
                            (click)="reset()"
                        /></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end::Content container-->
    </div>
    <!--begin::Content-->

    <div *ngIf="!isLoadSpinner" id="kt_app_content" class="app-content flex-column-fluid mb-4">
      <!--begin::Content container-->
      <div id="kt_app_content_container" class="app-container container-fluid">
        <!--begin::Card-->
        <div class="card pt-10">
          <!--begin::Card header-->
          <div class="d-flex flex-wrap header-grid align-items-center mb-10">
            <div class="section_title">
              <h1 class="section-heading">Liste des salariés</h1>
            </div>
            <!--begin::Tab nav-->
            <div class="d-flex justify-content-end">
              <ul class="nav nav-pills me-11">
                <li class="nav-item m-0">
                  <a
                    class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary me-3"
                    data-bs-toggle="tab"
                    href="#kt_employee_targets_card_pane"
                  >
                    <i class="ki-duotone ki-element-plus fs-1">
                      <span class="path1"></span>
                      <span class="path2"></span>
                      <span class="path3"></span>
                      <span class="path4"></span>
                      <span class="path5"></span>
                    </i>
                  </a>
                </li>
                <li class="nav-item m-0">
                  <a
                    class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary active"
                    data-bs-toggle="tab"
                    href="#kt_employee_targets_table_pane"
                  >
                    <i class="ki-duotone ki-row-horizontal fs-2">
                      <span class="path1"></span>
                      <span class="path2"></span>
                    </i>
                  </a>
                </li>
              </ul>
            </div>
            <!--end::Tab nav-->
          </div>

          <!--end::Card header-->
          <!--begin::Card body-->
          <div class="card-body pt-0">
            <div class="tab-content for-web">
              <!--begin::Tab pane-->
              <div id="kt_employee_targets_card_pane" class="tab-pane fade">
                <!--begin::Row-->
                <div class="row g-6 g-xl-9 justify-content-center">
                  <!--begin::Col-->
                  <div
                    class="col-md-6 col-xxl-4"
                    *ngFor="let s of listsalaries; let index = index"
                  >
                    <!--begin::Card-->
                    <div class="card pt-5 p-5">
                      <div class="toolss">
                        <div class="dropdown">
                          <button
                            class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                            type="button"
                            id="dropdownMenuButton"
                            data-bs-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            <svg
                              width="19"
                              height="5"
                              viewBox="0 0 19 5"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="2.44739"
                                cy="2.44739"
                                r="2.44739"
                                transform="matrix(1 0 0 -1 0 4.89478)"
                                fill="#265D91"
                              />
                              <circle
                                cx="2.44739"
                                cy="2.44739"
                                r="2.44739"
                                transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                fill="#265D91"
                              />
                              <circle
                                cx="2.44739"
                                cy="2.44739"
                                r="2.44739"
                                transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                fill="#265D91"
                              />
                            </svg>
                          </button>
                          <div
                            class="dropdown-menu"
                            aria-labelledby="dropdownMenuButton"
                          >
                            <a
                              class="dropdown-item"
                              [routerLink]="['/detailemployee', s.id]"
                              style="cursor: pointer"
                            >
                              Voir Détail
                            </a>
                            <a
                              class="dropdown-item"
                              (click)="openModal(modifier_salarie, s)"
                              style="cursor: pointer"
                            >
                              Modifier
                            </a>
                          </div>
                        </div>
                      </div>

                      <!--begin::Card body-->
                      <div class="card-body d-flex flex-center flex-column">
                        <!--begin::Avatar-->
                        <div
                          class="symbol symbol-65px symbol-circle mb-5 mt-10"
                        >
                          <img
                            *ngIf="s.image_url && s.image_url != 'avatar.png'"
                            class="table-img circle-img"
                            src="{{ urlimage + s.image_url }}"
                            alt=""
                            width="50px"
                          />
                          <img
                            *ngIf="s.image_url && s.image_url == 'avatar.png'"
                            class="table-img circle-img"
                            src="{{
                              url + '/Company/file/gallery_company/avatar.png'
                            }}"
                            alt=""
                            width="50px"
                          />
                        </div>
                        <!--end::Avatar-->
                        <!--begin::Name-->
                        <a class="fs-4 text-gray-800 text-center fw-bold mb-0">
                          {{ s.last_name }} {{ s.first_name }}
                        </a>
                        <!--end::Name-->
                        <!--begin::Position-->
                        <!--end::Position-->
                        <!--begin::Info-->
                        <div class="content-card">
                          <!--begin::Stats-->
                          <div class="py-3 px-4 mx-2">
                            <div class="badge-annee">
                              <span>Email professionnel :</span
                              >{{ s.emailProClient ? s.emailProClient : "---" }}
                            </div>
                          </div>

                          <div class="py-3 px-4 mx-2">
                            <div class="badge-annee">
                              <span>Poste :</span>
                              {{ s.poste ? s.poste : "---" }}
                            </div>
                          </div>
                        </div>

                        <!--end::Info-->
                      </div>
                      <div class="foot p-5">
                        <div class="poste" *ngIf="s.linkedin_link != null">
                          <span (click)="redirectToLinkedIn(s.linkedin_link)">
                            <svg
                              width="17"
                              height="18"
                              viewBox="0 0 17 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0_426_2396)">
                                <path
                                  d="M14.2669 17.8389H2.84767C1.3399 17.8389 0.113281 16.5429 0.113281 14.9497V2.88923C0.113281 1.296 1.3399 0 2.84767 0H14.2669C15.7742 0 17.0008 1.296 17.0008 2.88923V14.9502C17.0008 16.5434 15.7742 17.8389 14.2669 17.8389ZM5.81961 14.7475H5.8231V7.05277H3.5621V14.7475H5.81918H5.81961ZM4.69108 6.00185C4.86298 6.00209 5.03325 5.96642 5.19211 5.89687C5.35098 5.82733 5.49532 5.72528 5.61688 5.59657C5.73844 5.46787 5.83482 5.31503 5.9005 5.14682C5.96618 4.97861 5.99987 4.79833 5.99964 4.61631C5.99895 4.24906 5.86086 3.89707 5.61561 3.63739C5.37035 3.37771 5.03792 3.2315 4.69108 3.23077C4.34406 3.23089 4.01129 3.37691 3.76591 3.63672C3.52053 3.89653 3.38263 4.24888 3.38251 4.61631C3.38263 4.98374 3.52053 5.33608 3.76591 5.5959C4.01129 5.85571 4.34406 6.00172 4.69108 6.00185ZM14.2799 14.748V10.5295C14.2799 8.45677 13.8549 6.86215 11.5708 6.86215C10.4728 6.86215 9.73572 7.49908 9.43277 8.10369H9.40226V7.05277H7.23715V14.7475H9.49423V10.9398C9.49423 9.93554 9.67425 8.964 10.8499 8.964C12.0059 8.964 12.0229 10.1123 12.0229 11.0045V14.7475H14.2799V14.748Z"
                                  fill="#265D91"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_426_2396">
                                  <rect width="17" height="18" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </span>
                        </div>
                        <div class="plus">
                          <a
                           
                            [routerLink]="[
                              '/candidats/profilecandidatesn',
                              s.id
                            ]"
                            >Voir plus</a
                          >
                        </div>
                      </div>
                      <!--end::Card body-->
                    </div>
                    <!--end::Card-->
                  </div>
                  <!--end::Col-->
                  <!--begin::Col-->
                  <div
                  class="alert alert-warning text-center mt-5"
                  role="alert"
                  *ngIf="listsalaries && !listsalaries.length"
                >
                  <img src="/assets/media/errors/no-data.png" alt="" class="mb-5" />
                  <span class="empty-list"> La liste est vide </span>
                </div>
                <div class="pagination" *ngIf="listsalaries && listsalaries.length">
                  <app-pagination
                    [data]="listsalaries"
                    [lengthData]="totalItems"
                    (setPages)="getItems($event)"
                    [currentPageList]="currentPage"
                    [endexPageList]="endIndex"
                  >
                  </app-pagination>
                </div>
                  <!--end::Col-->
                </div>
                <!--end::Row-->
              </div>
              <!--end::Tab pane-->
              <!--begin::Tab pane-->
              <div
                id="kt_employee_targets_table_pane"
                class="tab-pane fade show active"
              >
                <div class="content">
                  <div class="card-body pt-3">
                    <!--begin::Table-->
                    <div class="table-responsive"  id="kt_customers_table">
                      <table
                        class="table align-middle fs-6 gy-5 style-table"
                       
                      >
                        <thead>
                          <tr
                            class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0"
                          >
                            <ng-container
                              *ngFor="let item of listNames; let i = index"
                            >
                              <th
                                class="min-w-175px"
                                [ngClass]="{ 'th-fixed': item === 'Nom' }"
                              >
                                <span>{{ item }}</span>
                                <i
                                  *ngIf="
                                    ![
                                      'Image',
                                      'CV',
                                      'Dossier de compétence',
                                      'Score wegestu',
                                      'Réponses'
                                    ].includes(item)
                                  "
                                  (click)="sortData(item)"
                                  class="fa-solid fa-sort cursor-pointer"
                                ></i>
                              </th>
                            </ng-container>

                            <th class="min-w-90px"><span>Actions</span></th>
                            <th class="min-w-70px">
                              <div class="dropdown">
                                <button
                                  class="dropdown-toggle"
                                  type="button"
                                  id="dropdownMenuButton"
                                  data-bs-toggle="dropdown"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="28"
                                    height="28"
                                    viewBox="0 0 28 28"
                                    fill="none"
                                  >
                                    <g filter="url(#filter0_d_588_1699)">
                                      <rect
                                        x="4"
                                        width="20"
                                        height="20"
                                        rx="4"
                                        fill="#63C3E8"
                                        fill-opacity="0.12"
                                        shape-rendering="crispEdges"
                                      />
                                    </g>
                                    <path
                                      d="M17.5 10.6H14.6V13.5C14.6 13.8314 14.3314 14.1 14 14.1C13.6686 14.1 13.4 13.8314 13.4 13.5V10.6H10.5C10.1686 10.6 9.9 10.3314 9.9 10C9.9 9.66863 10.1686 9.4 10.5 9.4H13.4V6.5C13.4 6.16863 13.6686 5.9 14 5.9C14.3314 5.9 14.6 6.16863 14.6 6.5V9.4H17.5C17.8314 9.4 18.1 9.66863 18.1 10C18.1 10.3314 17.8314 10.6 17.5 10.6Z"
                                      fill="#265D91"
                                      stroke="#265D91"
                                      stroke-width="0.2"
                                    />
                                    <defs>
                                      <filter
                                        id="filter0_d_588_1699"
                                        x="0"
                                        y="0"
                                        width="28"
                                        height="28"
                                        filterUnits="userSpaceOnUse"
                                        color-interpolation-filters="sRGB"
                                      >
                                        <feFlood
                                          flood-opacity="0"
                                          result="BackgroundImageFix"
                                        />
                                        <feColorMatrix
                                          in="SourceAlpha"
                                          type="matrix"
                                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                          result="hardAlpha"
                                        />
                                        <feOffset dy="4" />
                                        <feGaussianBlur stdDeviation="2" />
                                        <feComposite
                                          in2="hardAlpha"
                                          operator="out"
                                        />
                                        <feColorMatrix
                                          type="matrix"
                                          values="0 0 0 0 0.14902 0 0 0 0 0.364706 0 0 0 0 0.568627 0 0 0 0.13 0"
                                        />
                                        <feBlend
                                          mode="normal"
                                          in2="BackgroundImageFix"
                                          result="effect1_dropShadow_588_1699"
                                        />
                                        <feBlend
                                          mode="normal"
                                          in="SourceGraphic"
                                          in2="effect1_dropShadow_588_1699"
                                          result="shape"
                                        />
                                      </filter>
                                    </defs>
                                  </svg>
                                </button>
                                <div class="dropdown-table">
                                  <div
                                    class="dropdown-menu"
                                    aria-labelledby="dropdownMenuButton"
                                  >
                                    <div
                                      class="d-flex checkbox mb-2 menu"
                                      *ngFor="
                                        let item of dataHeader;
                                        let i = index
                                      "
                                    >
                                      <div
                                        class="form-check form-check-sm form-check-custom form-check-solid"
                                        *ngIf="item.name != 'checkbox'"
                                      >
                                        <input
                                          class="form-check-input checkbox-border"
                                          [checked]="
                                            (item.checked == 'oui' &&
                                              !item.checked_user) ||
                                            (item.checked_user == 'oui' &&
                                              (item.checked == 'non' ||
                                                item.checked == 'oui'))
                                          "
                                          (change)="
                                            changeSelectionElement(
                                              $event,
                                              item,
                                              i
                                            )
                                          "
                                          type="checkbox"
                                          value="1"
                                          [disabled]="
                                            item.name === 'Image' ||
                                            item.name === 'Nom'
                                          "
                                        />
                                        <a class="dropdown-item">{{
                                          item.name
                                        }}</a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </th>
                          </tr>
                        </thead>
                        <tbody class="fw-semibold text-gray-600">
                          <tr *ngFor="let s of listsalaries; let index = index">
                            <td *ngIf="listNames.includes('Image')">
                              <img
                                *ngIf="
                                  s.image_url && s.image_url != 'avatar.png'
                                "
                                class="table-img circle-img"
                                src="{{ urlimage + s.image_url }}"
                                alt=""
                                width="50px"
                              />
                              <img
                                *ngIf="
                                  s.image_url && s.image_url == 'avatar.png'
                                "
                                class="table-img circle-img"
                                src="{{
                                  url +
                                    '/Company/file/gallery_company/avatar.png'
                                }}"
                                alt=""
                                width="50px"
                              />
                            </td>
                            <td
                              *ngIf="listNames.includes('Nom')"
                              class="td-fixed"
                            >
                              <a
                                [routerLink]="[
                                  '/candidats/profilecandidatesn',
                                  s.id
                                ]"
                                class="first-td"
                              >
                                {{ s.last_name ? s.last_name : "---" }}
                                {{ s.first_name ? s.first_name : "---" }}
                              </a>
                            </td>

                            <td *ngIf="listNames.includes('Poste')">
                              <span> {{ s.poste ? s.poste : "---" }}</span>
                            </td>
                            <td *ngIf="listNames.includes('Projet')">
                              <span>{{
                                s.project_names ? s.project_names : "---"
                              }}</span>
                            </td>
                            <td *ngIf="listNames.includes('Expérience')">
                              <span *ngIf="s.years_of_experience !== '0 ans'">
                                {{
                                  s.years_of_experience
                                    ? s.years_of_experience
                                    : "---"
                                }}
                              </span>
                              <span *ngIf="s.years_of_experience === '0 ans'"
                                >---</span
                              >
                            </td>
                            <td *ngIf="listNames.includes('Salaire')">
                              <span *ngIf="s.salary"
                                >{{ s.salary }} &euro;</span
                              >
                              <span *ngIf="!s.salary">---</span>
                            </td>
                            <td *ngIf="listNames.includes('N°Tel')">
                              <span>{{
                                s.phone_number ? s.phone_number : "---"
                              }}</span>
                            </td>

                            <td *ngIf="listNames.includes('Email Personnel')">
                              <span>{{ s.email ? s.email : "---" }}</span>
                            </td>
                            <td
                              *ngIf="listNames.includes('Email Professionnel')"
                            >
                              <span>{{
                                s.emailProClient ? s.emailProClient : "---"
                              }}</span>
                            </td>

                            <td *ngIf="listNames.includes('CV')">
                              <svg
                                class="cc"
                                *ngIf="s.cv"
                                xmlns="http://www.w3.org/2000/svg"
                                width="26"
                                (click)="downloadFile(s)"
                                height="26"
                                viewBox="0 0 26 26"
                                fill="none"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M25.4273 4.05958V21.4387C25.4273 22.515 24.9783 23.5483 24.1801 24.3092C23.382 25.0701 22.2981 25.4982 21.1692 25.4982H4.25806C3.12915 25.4982 2.04528 25.0701 1.24716 24.3092C0.449034 23.5483 0 22.515 0 21.4387V4.05958C0 2.98329 0.449034 1.94995 1.24716 1.18903C2.04528 0.428104 3.12915 0 4.25806 0H21.1692C22.2981 0 23.382 0.428104 24.1801 1.18903C24.9783 1.94995 25.4273 2.98329 25.4273 4.05958ZM11.7058 19.7678C12.1182 20.1369 12.7193 20.2295 13.2288 20.0201C13.3766 19.9584 13.5118 19.8739 13.6314 19.7678L17.8543 15.9928C18.4216 15.4868 18.4497 14.636 17.919 14.0965C17.387 13.5557 16.4959 13.5275 15.9287 14.0348L14.0762 15.6908V6.71006C14.0762 5.96927 13.4456 5.36805 12.6686 5.36805C11.8916 5.36805 11.261 5.96927 11.261 6.71006V15.6908L9.40855 14.0348C8.84127 13.5275 7.95025 13.5557 7.41817 14.0965C6.88749 14.636 6.91565 15.4868 7.48292 15.9928L11.7058 19.7678Z"
                                  fill="#F58F29"
                                />
                              </svg>
                              <div *ngIf="!s.cv">--</div>
                            </td>
                            <td
                              *ngIf="
                                listNames.includes('Dossier de compétence')
                              "
                            >
                              <svg
                                class="cc"
                                *ngIf="s.cv_wegestu"
                                xmlns="http://www.w3.org/2000/svg"
                                width="26"
                                (click)="downloadFile(s)"
                                height="26"
                                viewBox="0 0 26 26"
                                fill="none"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M25.4273 4.05958V21.4387C25.4273 22.515 24.9783 23.5483 24.1801 24.3092C23.382 25.0701 22.2981 25.4982 21.1692 25.4982H4.25806C3.12915 25.4982 2.04528 25.0701 1.24716 24.3092C0.449034 23.5483 0 22.515 0 21.4387V4.05958C0 2.98329 0.449034 1.94995 1.24716 1.18903C2.04528 0.428104 3.12915 0 4.25806 0H21.1692C22.2981 0 23.382 0.428104 24.1801 1.18903C24.9783 1.94995 25.4273 2.98329 25.4273 4.05958ZM11.7058 19.7678C12.1182 20.1369 12.7193 20.2295 13.2288 20.0201C13.3766 19.9584 13.5118 19.8739 13.6314 19.7678L17.8543 15.9928C18.4216 15.4868 18.4497 14.636 17.919 14.0965C17.387 13.5557 16.4959 13.5275 15.9287 14.0348L14.0762 15.6908V6.71006C14.0762 5.96927 13.4456 5.36805 12.6686 5.36805C11.8916 5.36805 11.261 5.96927 11.261 6.71006V15.6908L9.40855 14.0348C8.84127 13.5275 7.95025 13.5557 7.41817 14.0965C6.88749 14.636 6.91565 15.4868 7.48292 15.9928L11.7058 19.7678Z"
                                  fill="#F58F29"
                                />
                              </svg>
                              <div *ngIf="!s.cv_wegestu">--</div>
                            </td>

                            <td
                              *ngIf="listNames.includes('Dernière connexion')"
                            >
                              <span>
                                {{
                                  !s.last_connection
                                    ? "---"
                                    : s.last_connection
                                        .split(
                                          "
                                                            "
                                        )[0]
                                        .split("-")
                                        .reverse()
                                        .join("/")
                                }}
                              </span>
                            </td>

                            <td class="actions">
                              <div class="tools">
                                <div class="dropdown">
                                  <button
                                    class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                    type="button"
                                    id="dropdownMenuButton"
                                    data-bs-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                  >
                                    <svg
                                      width="19"
                                      height="5"
                                      viewBox="0 0 19 5"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <circle
                                        cx="2.44739"
                                        cy="2.44739"
                                        r="2.44739"
                                        transform="matrix(1 0 0 -1 0 4.89478)"
                                        fill="#265D91"
                                      />
                                      <circle
                                        cx="2.44739"
                                        cy="2.44739"
                                        r="2.44739"
                                        transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                        fill="#265D91"
                                      />
                                      <circle
                                        cx="2.44739"
                                        cy="2.44739"
                                        r="2.44739"
                                        transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                        fill="#265D91"
                                      />
                                    </svg>
                                  </button>
                                  <div
                                    class="dropdown-menu"
                                    aria-labelledby="dropdownMenuButton"
                                  >
                                    <a
                                      class="dropdown-item"
                                     
                                      (click)="redirectToDetail(s)"
                                      style="cursor: pointer"
                                    >
                                      Voir Détail
                                    </a>
                                    <!-- [routerLink]="['/detailemployee', s.id]" -->
                                    <a
                                      class="dropdown-item"
                                      (click)="openModal(modifier_salarie, s)"
                                      style="cursor: pointer"
                                    >
                                      Modifier
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div
                    class="alert alert-warning text-center mt-5"
                    role="alert"
                    *ngIf="listsalaries && !listsalaries.length"
                  >
                    <img src="/assets/media/errors/no-data.png" alt="" class="mb-5" />
                    <span class="empty-list"> La liste est vide </span>
                  </div>

                  <div class="pagination" *ngIf="listsalaries && listsalaries.length">
                    <app-pagination
                      [data]="listsalaries"
                      [lengthData]="totalItems"
                      (setPages)="getItems($event)"
                      [currentPageList]="currentPage"
                      [endexPageList]="endIndex"
                    >
                    </app-pagination>
                  </div>
                    <!--end::Table-->
                  </div>
                </div>
              </div>
              <!--end::Tab pane-->
            </div>

            <div class="tab-content for-mobile">
              <!--begin::Tab pane-->
              <div
                id="kt_employee_targets_card_pane"
                class="tab-pane fade show active"
              >
                <!--begin::Row-->
                <div class="row g-6 g-xl-9 justify-content-center">
                  <!--begin::Col-->
                  <div
                    class="col-md-6 col-xxl-4"
                    *ngFor="let s of listsalaries; let index = index"
                  >
                    <!--begin::Card-->
                    <div class="card pt-5 p-5">
                      <div class="tools">
                        <div class="tools">
                          <div class="pays" *ngIf="s.current_country != 'null'">
                            {{ s.current_country ? s.current_country : "---" }}
                          </div>
                          <div class="pays" *ngIf="s.current_country == 'null'">
                            ---
                          </div>
                        </div>
                      </div>
                      <!--begin::Card body-->
                      <div class="card-body d-flex flex-center flex-column">
                        <!--begin::Avatar-->
                        <div
                          class="symbol symbol-65px symbol-circle mb-5 mt-10"
                        >
                          <img
                            *ngIf="s.image_url && s.image_url != 'avatar.png'"
                            class="table-img"
                            src="{{ urlimage + s.image_url }}"
                            alt=""
                            width="50px"
                          />
                          <img
                            *ngIf="s.image_url && s.image_url == 'avatar.png'"
                            class="table-img"
                            src="/assets/media/avatar.png"
                            alt=""
                            width="50px"
                          />
                          <img
                            *ngIf="!s.image_url || s.image_url === undefined"
                            class="table-img"
                            src="/assets/media/avatar.png"
                            alt=""
                            width="50px"
                          />
                        </div>
                        <!--end::Avatar-->
                        <!--begin::Name-->
                        <a class="fs-4 text-gray-800 text-center fw-bold mb-0">
                          {{ s.first_name }} {{ s.last_name }}
                        </a>
                        <!--end::Name-->
                        <!--begin::Position-->
                        <!--end::Position-->
                        <!--begin::Info-->
                        <div class="content-card">
                          <!--begin::Stats-->
                          <div class="py-3 px-4 mx-2">
                            <div class="badge-annee">
                              <span>Mail Professionnel :</span
                              >{{
                                s.years_of_experience
                                  ? s.years_of_experience
                                  : "---"
                              }}
                            </div>
                          </div>

                          <div class="py-3 px-4 mx-2">
                            <div class="badge-annee">
                              <span>Poste :</span>
                              {{ s.salary ? s.salary + " &euro;" : "---" }}
                            </div>
                          </div>
                          <div class="py-3 px-4 mx-2">
                            <div class="badge-annee">
                              <span>Tjm :</span>
                              {{ s.tjm ? s.tjm + " &euro;" : "---" }}
                            </div>
                          </div>
                          <div class="py-3 px-4 mx-2">
                            <div class="badge-annee">
                              <span>PAYS :</span>
                              {{
                                s.current_country ? s.current_country : "---"
                              }}
                            </div>
                          </div>

                          <!--end::Stats-->
                          <!--begin::Stats-->

                          <!--end::Stats-->
                        </div>

                        <!--end::Info-->
                      </div>
                      <div class="foot p-5">
                        <div class="poste" *ngIf="s.linkedin_link != null">
                          <span (click)="redirectToLinkedIn(s.linkedin_link)">
                            <svg
                              width="17"
                              height="18"
                              viewBox="0 0 17 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0_426_2396)">
                                <path
                                  d="M14.2669 17.8389H2.84767C1.3399 17.8389 0.113281 16.5429 0.113281 14.9497V2.88923C0.113281 1.296 1.3399 0 2.84767 0H14.2669C15.7742 0 17.0008 1.296 17.0008 2.88923V14.9502C17.0008 16.5434 15.7742 17.8389 14.2669 17.8389ZM5.81961 14.7475H5.8231V7.05277H3.5621V14.7475H5.81918H5.81961ZM4.69108 6.00185C4.86298 6.00209 5.03325 5.96642 5.19211 5.89687C5.35098 5.82733 5.49532 5.72528 5.61688 5.59657C5.73844 5.46787 5.83482 5.31503 5.9005 5.14682C5.96618 4.97861 5.99987 4.79833 5.99964 4.61631C5.99895 4.24906 5.86086 3.89707 5.61561 3.63739C5.37035 3.37771 5.03792 3.2315 4.69108 3.23077C4.34406 3.23089 4.01129 3.37691 3.76591 3.63672C3.52053 3.89653 3.38263 4.24888 3.38251 4.61631C3.38263 4.98374 3.52053 5.33608 3.76591 5.5959C4.01129 5.85571 4.34406 6.00172 4.69108 6.00185ZM14.2799 14.748V10.5295C14.2799 8.45677 13.8549 6.86215 11.5708 6.86215C10.4728 6.86215 9.73572 7.49908 9.43277 8.10369H9.40226V7.05277H7.23715V14.7475H9.49423V10.9398C9.49423 9.93554 9.67425 8.964 10.8499 8.964C12.0059 8.964 12.0229 10.1123 12.0229 11.0045V14.7475H14.2799V14.748Z"
                                  fill="#265D91"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_426_2396">
                                  <rect width="17" height="18" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </span>
                        </div>
                        <div class="plus">
                          <a
                            data-bs-toggle="modal"
                            data-bs-target="#details_salarie"
                            [routerLink]="[
                              '/candidats/profilecandidatesn',
                              s.id
                            ]"
                            >Voir plus</a
                          >
                        </div>
                      </div>
                      <!--end::Card body-->
                    </div>
                    <!--end::Card-->
                  </div>
                  <!--end::Col-->
                  <!--begin::Col-->
                  <div
                  class="alert alert-warning text-center mt-5"
                  role="alert"
                  *ngIf="listsalaries && !listsalaries.length"
                >
                  <img src="/assets/media/errors/no-data.png" alt="" class="mb-5" />
                  <span class="empty-list"> La liste est vide </span>
                </div>
                <div class="pagination" *ngIf="listsalaries && listsalaries.length">
                  <app-pagination
                    [data]="listsalaries"
                    [lengthData]="totalItems"
                    (setPages)="getItems($event)"
                    [currentPageList]="currentPage"
                    [endexPageList]="endIndex"
                  >
                  </app-pagination>
                </div>
                  <!--end::Col-->
                </div>
                <!--end::Row-->
              </div>
              <!--end::Tab pane-->
            </div>
            <!--end::Table-->

          
          </div>
          <!--end::Card body-->
        </div>
        <!--end::Card-->
        <!--begin::Modals-->
        <!--begin::Modal - Customers - Add-->
      

        <!--end::Modal - Customers - Add-->
        <!--begin::Modal - Adjust Balance-->

        <!--end::Modal - New Card-->
        <!--end::Modals-->
      </div>
      <!--end::Content container-->
    </div>

    <!--end::Content-->
  </div>
  <!--end::Content wrapper-->
  <!--begin::Footer-->

  <!--end::Footer-->
  <!--end:::Main-->
</div>
<ng-template #add_employee>
  <div
    class="modal-dialog-centered"
    id="add_employee"
    tabindex="-1"
    aria-hidden="true"
  >
    <!--begin::Modal dialog-->

    <!--begin::Modal content-->
    <div class="modal-content pt-5 pb-5">
      <!--begin::Modal header-->
      <div class="modal-header">
        <!--begin::Modal title-->
        <h2 class="fw-bold">Ajouter salarié</h2>
        <!--end::Modal title-->
        <!--begin::Close-->
        <div
          id="ModalClose_add_salarie"
          class="btn btn-icon btn-sm btn-active-icon-primary"
          (click)="close_modal_add()"
        >
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
        <!--end::Close-->
      </div>

      <!--end::Modal header-->
      <!--begin::Modal body-->
      <!-- modal ajout salarie -->
      <div class="modal-body mx-5 my-5">
        <!--begin::Form-->
        <form [formGroup]="formsalaire">
          <div class="">
            <div class="card-body">
              <div class="flex_input">
                <span class="required mb-3">Email personnel </span>
                <input
                  type="text"
                  (keyup)="getsalarieByEmail($event)"
                  id="Nom"
                  class="form-control form-control-solid mb-3"
                  formControlName="email"
                  placeholder="email personnel"
                />

                <div
                  *ngIf="
                    formsalaire.get('email')?.hasError('required') &&
                    formsalaire.get('email')?.touched
                  "
                  class="text-danger"
                >
                  Le champ "Email" est obligatoire.
                </div>
                <div
                  *ngIf="
                    formsalaire.get('email')?.hasError('pattern') &&
                    formsalaire.get('email')?.touched
                  "
                  class="text-danger"
                >
                  La valeur de ce champ doit avoir une adresse email valide.
                </div>
                <div *ngIf="consultantExterneExists" class="text-danger">
                  Ce candidat est déjà un consultant externe pour cette
                  entreprise.
                </div>
                <div *ngIf="Existscandidat" class="text-danger">
                  Ce candidat est déjà un consultant pour cette entreprise.
                </div>
                <div *ngIf="Notexistcandidat" class="text-danger">
                  Le profil utilisateur n'a pas été complété .
                </div>
              </div>
              <div class="flex_input">
                <span class="mb-3">Email professionnel </span>
                <input
                  type="text"
                  id="Nom"
                  class="form-control form-control-solid mb-3"
                  formControlName="emailProClient"
                  placeholder="email professionnel"
                />

                <div
                  *ngIf="
                    formsalaire.get('emailProClient')?.hasError('pattern') &&
                    formsalaire.get('emailProClient')?.touched
                  "
                  class="text-danger"
                >
                  La valeur de ce champ doit avoir une adresse email valide.
                </div>
              </div>
              <div class="flex_input">
                <span class="required mb-3">Nom salarié </span>
                <input
                  type="text"
                  id="Nom"
                  class="form-control form-control-solid mb-3"
                  formControlName="first_name"
                  placeholder="Nom"
                />

                <div
                  *ngIf="
                    formsalaire.get('first_name')?.hasError('required') &&
                    formsalaire.get('first_name')?.touched
                  "
                  class="text-danger"
                >
                  Le champ "Nom" est obligatoire.
                </div>
                <div
                  *ngIf="
                    formsalaire.get('first_name')?.hasError('pattern') &&
                    formsalaire.get('first_name')?.touched
                  "
                  class="text-danger"
                >
                  La valeur de ce champ doit avoir un nom valide.
                </div>
              </div>
              <div class="flex_input">
                <span class="required mb-3">Prénom salarié </span>
                <input
                  type="text"
                  id="Nom"
                  class="form-control form-control-solid mb-3"
                  formControlName="last_name"
                  placeholder="prénom"
                />
                <div
                  *ngIf="
                    formsalaire.get('last_name')?.hasError('required') &&
                    formsalaire.get('last_name')?.touched
                  "
                  class="text-danger"
                >
                  Le champ "Prénom" est obligatoire.
                </div>
                <div
                  *ngIf="
                    formsalaire.get('last_name')?.hasError('pattern') &&
                    formsalaire.get('last_name')?.touched
                  "
                  class="text-danger"
                >
                  La valeur de ce champ doit avoir un prénom valide.
                </div>
              </div>
              <div class="flex_input">
                <span class="mb-3">LinkedIn</span>

                <input
                  type="text"
                  name="linkedin"
                  id="linkedin"
                  class="form-control form-control-solid mb-3"
                  placeholder="https://www.linkedin.com/in/"
                  formControlName="linkedin_link"
                  (input)="setValidatorRequirements()"
                />
                <app-feild-error
                  [control]="formsalaire.get('linkedin_link')"
                ></app-feild-error>
                <!-- <div *ngIf="formsalaire.get('linkedin_link')?.hasError('pattern') && formsalaire.get('linkedin_link')?.touched" class="text-danger">
                                        Entrer une URL valide exemple: https://www.linkedin.com/in/exemple
                                    </div> -->
              </div>
              <div class="flex_input">
                <div class="w-100">
                  <div class="labels">
                    <label for="cv" class="form-label mb-3">
                      Importer CV Le cv doit être (.pdf,.docx,.doc) {{ cv }}
                    </label>
                    <button *ngIf="showResetButtons && fileName !== '' && !iscv" class="more-label"
                    (click)="resetCV()">
                    <img src="assets/media/icons/icon-delete.png" alt="" width="30px"
                        class="cursor-pointer">
                </button>
                  </div>
                </div>
                <input *ngIf="!iscv"
                  id="fileInput"
                  #inputFile
                  type="file"
                  name="cv"
                  id="cv"
                  (change)="uploadFile($event); setValidatorRequirements()"
                  class="form-control mb-3"
                  [disabled]="isexiste"
                />

            
                <input  *ngIf="iscv"
                type="text"
                id="Nom"
                class="form-control form-control-solid mb-3"
                formControlName="cv"
                placeholder="cv" [readonly]="true"
              />

                <span style="color: red" *ngIf="fileError"
                  ><small>{{ fileError }} </small></span
                >
                <span style="color: red" *ngIf="fileExtention"
                  ><small>{{ fileExtention }} </small></span
                >
                <label> </label>
              </div>
              <!-- <div class="requis mb-5">
                <span class="requirements mt-5 mb-5">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_379_198)">
                      <path
                        d="M8 16C9.58225 16 11.129 15.5308 12.4446 14.6518C13.7602 13.7727 14.7855 12.5233 15.391 11.0615C15.9965 9.59966 16.155 7.99113 15.8463 6.43928C15.5376 4.88743 14.7757 3.46197 13.6569 2.34315C12.538 1.22433 11.1126 0.462403 9.56072 0.153721C8.00887 -0.15496 6.40034 0.00346629 4.93853 0.608967C3.47672 1.21447 2.22729 2.23985 1.34824 3.55544C0.469192 4.87104 0 6.41775 0 8C0.00229405 10.121 0.845886 12.1545 2.34568 13.6543C3.84547 15.1541 5.87897 15.9977 8 16ZM8 3.33334C8.19778 3.33334 8.39112 3.39199 8.55557 3.50187C8.72002 3.61175 8.84819 3.76793 8.92388 3.95065C8.99957 4.13338 9.01937 4.33445 8.98079 4.52843C8.9422 4.72241 8.84696 4.90059 8.70711 5.04044C8.56726 5.1803 8.38907 5.27554 8.19509 5.31412C8.00111 5.35271 7.80004 5.3329 7.61732 5.25722C7.43459 5.18153 7.27841 5.05336 7.16853 4.88891C7.05865 4.72446 7 4.53112 7 4.33334C7 4.06812 7.10536 3.81377 7.29289 3.62623C7.48043 3.43869 7.73478 3.33334 8 3.33334ZM7.33333 6.66667H8C8.35362 6.66667 8.69276 6.80715 8.94281 7.0572C9.19286 7.30724 9.33333 7.64638 9.33333 8V12C9.33333 12.1768 9.2631 12.3464 9.13807 12.4714C9.01305 12.5964 8.84348 12.6667 8.66667 12.6667C8.48986 12.6667 8.32029 12.5964 8.19526 12.4714C8.07024 12.3464 8 12.1768 8 12V8H7.33333C7.15652 8 6.98695 7.92977 6.86193 7.80474C6.73691 7.67972 6.66667 7.51015 6.66667 7.33334C6.66667 7.15653 6.73691 6.98696 6.86193 6.86193C6.98695 6.73691 7.15652 6.66667 7.33333 6.66667Z"
                        fill="#2b5d8f"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_379_198">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  &nbsp;Au moins l'un des champs CV ou LinkedIn est
                  requis.</span
                >
              </div> -->

              <div class="flex_input">
                <span class="mb-3">Poste</span>
                <input
                  type="text"
                  id="Poste"
                  class="form-control form-control-solid mb-3"
                  formControlName="poste"
                  placeholder="Poste"
                />
              </div>
              <div class="flex_input">
                <span class="mb-3">Salaire &euro;</span>
                <input
                  type="number"
                  id="num tel"
                  class="form-control form-control-solid mb-3"
                  formControlName="salary"
                  oninput="validity.valid||(value='0');"
                  min="0"
                  placeholder="Salaire"
                />
              </div>
              <div class="flex_input">
                <span class="mb-3">Projet</span>
                <ng-select
                  [multiple]="true"
                  [items]="listprojet"
                  class="form-select"
                  bindLabel="name"
                  formControlName="project_ids"
                  bindValue="id"
                  [placeholder]="'Projet'"
                  autoComplete
                  [notFoundText]="'Aucun élément trouvé'"
                >
                </ng-select>
              </div>

              <div class="flex_input">
                <span class="mb-3">Date du premier contrat</span>
                <input
                  type="date"
                  id="debut"
                  class="form-control mb-5"
                  formControlName="date_first_contract"
                />
              </div>
            </div>
          </div>
        </form>
        <!--end::Form-->
      </div>
      <div class="card-footer mx-5 my-7">
        <div class="actions">
          <a class="annuler cursor-pointer" (click)="close_modal_add()"
            >Annuler</a
          >
          <button
            class="confirmer"
            [disabled]="
              fileError ||
              fileExtention 
            "
            (click)="createsalarie()"
          >
            Confirmer
          </button>
        </div>
      </div>
      <!--end::Modal body-->
    </div>
    <!--end::Modal content-->
  </div>
  <!--end::Modal dialog-->

  <!--end::Modal dialog-->
</ng-template>

<ng-template #details_salarie>
  <div
    class="modal-dialog-centered"
    id="details_salarie"
    tabindex="-1"
    aria-hidden="true"
  >
    <!--begin::Modal dialog-->
    <!--begin::Modal content-->

    <!--begin::Modal content-->

    <!--begin::Modal content-->
    <div class="modal-content pt-5 pb-15">
      <!--begin::Modal header-->
      <div class="modal-header">
        <!--begin::Modal title-->
        <h2 class="fw-bold">Détail Salarié</h2>
        <!--end::Modal title-->
        <!--begin::Close-->
        <div
          id="ModalClose_add_salarie"
          class="btn btn-icon btn-sm btn-active-icon-primary"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="close_modal_add()"
        >
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
        <!--end::Close-->
      </div>

      <!--end::Modal header-->
      <!--begin::Modal body-->
      <!-- modal ajout salarie -->
      <div class="modal-body text-center mx-5 mx-xl-15 my-7">
        <!--begin::Form-->
        <form [formGroup]="formsalaire">
          <div class="">
            <div class="card-body">
              <div class="flex_input">
                <span class="required mb-3">Email personnel </span>
                <input
                  type="text"
                  (keyup)="getsalarieByEmail($event)"
                  id="Nom"
                  class="form-control form-control-solid mb-3"
                  formControlName="email"
                  placeholder="email personnel"
                  [readonly]="true"
                />
              </div>
              <div class="flex_input">
                <span class="mb-3">Email professionnel </span>
                <input
                  type="text"
                  id="Nom"
                  class="form-control form-control-solid mb-3"
                  formControlName="emailProClient"
                  placeholder="email professionnel"
                  [readonly]="true"
                />
              </div>
              <div class="flex_input">
                <span class="required mb-3">Nom salarié </span>
                <input
                  type="text"
                  id="Nom"
                  class="form-control form-control-solid mb-3"
                  formControlName="first_name"
                  placeholder="Nom"
                  [readonly]="true"
                />
              </div>
              <div class="flex_input">
                <span class="required mb-3">Prénom salarié </span>
                <input
                  type="text"
                  id="Nom"
                  class="form-control form-control-solid mb-3"
                  formControlName="last_name"
                  placeholder="prénom"
                  [readonly]="true"
                />
              </div>
              <div class="flex_input">
                <span class="required mb-3"
                  ><span class="required mb-3">LinkedIn</span></span
                >
                <input
                  type="text"
                  formControlName="linkedin_link"
                  id="web "
                  class="form-control mb-5"
                  placeholder="https://www.linkedin.com/in/votreprofil"
                  [readonly]="true"
                />
              </div>
              <div class="flex_input">
                <span class="required mb-3"
                  ><span class="required mb-3">cv</span></span
                >
                <input
                  type="text"
                  formControlName="cv"
                  id="web "
                  class="form-control mb-5"
                  [readonly]="true"
                />
              </div>

              <div class="flex_input">
                <span>Poste</span>
                <input
                  type="text"
                  id="Poste"
                  class="form-control form-control-solid mb-3"
                  formControlName="poste"
                  placeholder="Poste"
                  [readonly]="true"
                />
              </div>
              <div class="flex_input">
                <span>Salaire &euro;</span>
                <input
                  type="text"
                  id="num tel"
                  class="form-control form-control-solid mb-3"
                  formControlName="salary"
                  oninput="validity.valid||(value='0');"
                  min="0"
                  placeholder="Salaire"
                  [readonly]="true"
                />
              </div>
              <div class="flex_input">
                <span>Projet</span>
                <ng-select
                  [multiple]="true"
                  [items]="listprojet"
                  class="form-select"
                  bindLabel="name"
                  formControlName="project_ids"
                  bindValue="id"
                  [placeholder]="'Projet'"
                  autoComplete
                  [notFoundText]="'Aucun élément trouvé'"
                >
                </ng-select>
              </div>

              <div class="flex_input">
                <span>Date du premier contrat</span>
                <input
                  type="date"
                  id="debut"
                  class="form-control mb-5"
                  formControlName="date_first_contract"
                  [readonly]="true"
                />
              </div>
            </div>
          </div>
        </form>
        <!--end::Form-->
      </div>

      <!--end::Modal body-->
    </div>
    <!--end::Modal content-->
  </div>

  <!--end::Modal dialog-->
</ng-template>

<ng-template #modifier_salarie>
  <div
    class="modal-dialog-centered"
    id="modifier"
    tabindex="-1"
    aria-hidden="true"
  >
    <!--begin::Modal dialog-->
    <!--begin::Modal content-->

    <!--begin::Modal content-->

    <!--begin::Modal content-->
    <div class="modal-content pt-5 pb-5">
      <!--begin::Modal header-->
      <div class="modal-header">
        <!--begin::Modal title-->
        <h2 class="fw-bold">Modifier salarié</h2>
        <!--end::Modal title-->
        <!--begin::Close-->
        <div
          id="ModalClose_add_salarie"
          class="btn btn-icon btn-sm btn-active-icon-primary"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="close_modal_add()"
        >
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
        <!--end::Close-->
      </div>

      <!--end::Modal header-->
      <!--begin::Modal body-->
      <!-- modal ajout salarie -->
      <div class="modal-body text-center mx-5 my-7">
        <!--begin::Form-->
        <form [formGroup]="formsalaire">
          <div class="">
            <div class="card-body">
              <div class="flex_input">
                <span class="required mb-3">Email personnel </span>
                <input
                  type="text"
                  (keyup)="getsalarieByEmail($event)"
                  id="Nom"
                  class="form-control form-control-solid mb-3"
                  formControlName="email"
                  placeholder="email personnel"
                  [readonly]="true"
                />

                <div
                  *ngIf="
                    formsalaire.get('email')?.hasError('required') &&
                    formsalaire.get('email')?.touched
                  "
                  class="text-danger"
                >
                  Le champ "Email" est obligatoire.
                </div>
                <div
                  *ngIf="
                    formsalaire.get('email')?.hasError('pattern') &&
                    formsalaire.get('email')?.touched
                  "
                  class="text-danger"
                >
                  La valeur de ce champ doit avoir une adresse email valide.
                </div>
              </div>
              <div class="flex_input">
                <span class="mb-3">Email professionnel </span>
                <input
                  type="text"
                  id="Nom"
                  class="form-control form-control-solid mb-3"
                  formControlName="emailProClient"
                  placeholder="email professionnel"
                />

                <div
                  *ngIf="
                    formsalaire.get('emailProClient')?.hasError('pattern') &&
                    formsalaire.get('emailProClient')?.touched
                  "
                  class="text-danger"
                >
                  La valeur de ce champ doit avoir une adresse email valide.
                </div>
              </div>
              <div class="flex_input">
                <span class="required mb-3">Nom salarié </span>
                <input
                  type="text"
                  id="Nom"
                  class="form-control form-control-solid mb-3"
                  formControlName="first_name"
                  placeholder="Nom"
                  [readonly]="true"
                />

                <div
                  *ngIf="
                    formsalaire.get('first_name')?.hasError('required') &&
                    formsalaire.get('first_name')?.touched
                  "
                  class="text-danger"
                >
                  Le champ "Nom" est obligatoire.
                </div>
              </div>
              <div class="flex_input">
                <span class="required mb-3">Prénom salarié </span>
                <input
                  type="text"
                  id="Nom"
                  class="form-control form-control-solid mb-3"
                  formControlName="last_name"
                  placeholder="prénom"
                  [readonly]="true"
                />
                <div
                  *ngIf="
                    formsalaire.get('last_name')?.hasError('required') &&
                    formsalaire.get('last_name')?.touched
                  "
                  class="text-danger"
                >
                  Le champ "Nom" est obligatoire.
                </div>
              </div>
              <div class="flex_input">
                <span>LinkedIn</span>
                <input
                  type="text"
                  formControlName="linkedin_link"
                  id="web "
                  class="form-control mb-5"
                  placeholder="https://www.linkedin.com/in/votreprofil"
                  [readonly]="true"
                />

                <div
                  *ngIf="
                    formsalaire.get('linkedin_link')?.hasError('required') &&
                    formsalaire.get('linkedin_link')?.touched
                  "
                  class="text-danger"
                >
                  Le champ "linkedin_link" est obligatoire.
                </div>
              </div>
              <div class="flex_input">
                <span>cv</span>
                <input
                  type="text"
                  placeholder="cv"
                  formControlName="cv"
                  id="web "
                  class="form-control mb-5"
                  [readonly]="true"
                />

                <div
                  *ngIf="
                    formsalaire.get('cv')?.hasError('required') &&
                    formsalaire.get('cv')?.touched
                  "
                  class="text-danger"
                >
                  Le champ "cv" est obligatoire.
                </div>
              </div>

              <div class="flex_input">
                <span>Poste</span>
                <input
                  type="text"
                  id="Poste"
                  class="form-control form-control-solid mb-3"
                  formControlName="poste"
                  placeholder="Poste"
                />
              </div>
              <div class="flex_input">
                <span>Salaire &euro;</span>
                <input
                  type="number"
                  id="num tel"
                  class="form-control form-control-solid mb-3"
                  formControlName="salary"
                  oninput="validity.valid||(value='0');"
                  min="0"
                  placeholder="Salaire"
                />
              </div>
              <div class="flex_input">
                <span>Projet</span>
                <ng-select
                  [multiple]="true"
                  [items]="listprojet"
                  class="form-select mb-5"
                  bindLabel="name"
                  formControlName="project_ids"
                  bindValue="id"
                  [placeholder]="'Projet'"
                  autoComplete
                  [notFoundText]="'Aucun élément trouvé'"
                >
                </ng-select>
              </div>

              <div class="flex_input">
                <span>Date du premier contrat</span>
                <input
                  type="date"
                  id="debut"
                  class="form-control mb-5"
                  formControlName="date_first_contract"
                />
              </div>
            </div>
          </div>
        </form>
        <!--end::Form-->
      </div>
      <div class="card-footer mx-5 my-7">
        <div class="actions">
          <a
            href="#"
            class="annuler"
            data-bs-dismiss="modal"
            aria-label="Close"
            (click)="close_modal_add()"
            >Annuler</a
          >
          <button
            class="confirmer"
            [disabled]="formsalaire.get('salary')?.invalid"
            (click)="updatesalarier()"
          >
            Confirmer
          </button>
        </div>
      </div>
      <!--end::Modal body-->
    </div>
    <!--end::Modal content-->
  </div>

  <!--end::Modal dialog-->
</ng-template>

<ng-template #add_masse>
  <div class="modal-content" id="add_masse" tabindex="-1" aria-hidden="true">
    <!--begin::Modal dialog-->
    <!--begin::Modal content-->
    <div class="">
      <!--begin::Modal content-->
      <div class="content">
        <!--begin::Modal header-->
        <div class="modal-header">
          <!--begin::Modal title-->
          <h2 class="">Ajouter en masse</h2>
          <!--end::Modal title-->
          <!--begin::Close-->
          <div
            id="kt_customers_export_close"
            data-bs-dismiss="modal"
            class="btn btn-icon btn-sm btn-active-icon-primary"
          >
            <i class="ki-duotone ki-cross fs-1" (click)="closeModal()">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
          </div>
          <!--end::Close-->
        </div>
        <!--end::Modal header-->
        <!--begin::Modal body-->
        <div class="modal-body scroll-y mx-5 mx-xl-15 my-7">
          <label for="masse">Votre ficher CSV</label>
          <input
            type="file"
            name="masse"
            id="masse"
            class="form-control"
            (change)="onFileSelected($event)"
          />
          <span style="color: red" *ngIf="fileExtentions"
            ><small>{{ fileExtentions }} </small></span
          >
          <div class="modal-footer">
            <button
              type="reset"
              (click)="closeModal()"
              id="kt_customers_export_cancel"
              data-bs-dismiss="modal"
              class="footer-btn annuler me-3"
            >
              Annuler
            </button>
            <button
              [disabled]="fileExtentions != '' || !selectedFile"
              type="submit"
              id="kt_customers_export_submit"
              (click)="addBulkCandidates()"
              class="footer-btn confirmer"
            >
              <span class="indicator-label">Confirmer</span>
              <span class="indicator-progress"
                >Please wait...
                <span
                  class="spinner-border spinner-border-sm align-middle ms-2"
                ></span
              ></span>
            </button>
          </div>
          <!--end::Form-->
        </div>
        <!--end::Modal body-->
      </div>
    </div>
  </div>
</ng-template>
